export const nl = {
  upload: "Uploaden",
  cancel: "Annuleren",
  close: "Sluiten",
  uploading: "Uploaden...",
  uploaded: "Geupload",
  fetching: "Bezig met het ophalen van afbeelding vanaf $1$...",
  poweredBy: "Mede mogelijk gemaakt door $1$",
  needHelp: "Hulp nodig?",
  units: {
    px: "px",
    "%": "%",
    deg: "°",
  },
  errors: {
    response_not_ok:
      "Er is een fout opgetreden bij het ophalen van dit bestand",
    unable_to_search: "Er is een fout opgetreden bij het zoeken",
    invalid_service_url: "Dit is geen $1$-URL",
    invalid_url: "Deze URL is ongeldig",
    upload_aborted: "Je upload is geannuleerd",
    upload_error: "Er is een fout opgetreden bij het uploaden van dit bestand",
    file_type_not_allowed: "Dit bestandstype wordt niet ondersteund",
    file_too_large: "Het bestand moet kleiner zijn dan $1$",
  },
  help: {
    loading: "Bezig met het laden van hulp...",
    close: "Hulp sluiten",
  },
  services: {
    default: {
      heading: "Selecteer een afbeelding",
    },
    local: {
      title: "Kies een bestand",
      button: "Selecteer een bestand",
      or: "of",
      drop: "Sleep hier een bestand om te uploaden",
    },
    camera: {
      title: "Camera",
      button: "Webcam foto",
      switch: "Switch camera",
      waiting: "Wachten op camera permissie...",
      unableToRead:
        "We kunnen de video van uw camera niet lezen. Dit kan zijn omdat u niet de vereiste toestemming hebt verleend of omdat uw apparaat geen cameratoegang ondersteunt.",
    },
    microlink: {
      button: "Importeer van $1$",
      label: "$1$ $2$ URL",
      placeholder: "Voer een $1$-$2$-URL in",
      type: "post",
    },
    url: {
      title: "Directe URL",
      label: "Afbeeldings-URL",
      placeholder: "Voer een afbeeldings-URL in",
    },
    instagram: {
      title: "Instagram",
    },
    facebook: {
      title: "Facebook",
    },
    flickr: {
      title: "Flickr",
      type: "foto",
    },
    ninegag: {
      title: "9GAG",
      type: "foto",
    },
    deviantart: {
      title: "DeviantArt",
    },
    artstation: {
      title: "ArtStation",
    },
    twitter: {
      title: "Twitter",
      type: "foto tweet",
    },
    pinterest: {
      title: "Pinterest",
      type: "pin",
    },
    flipboard: {
      title: "Flipboard",
      type: "artikel",
    },
    fotki: {
      title: "Fotki",
      type: "foto",
    },
    linkedin: {
      title: "LinkedIn",
    },
    reddit: {
      title: "Reddit",
    },
    tumblr: {
      title: "Tumblr",
    },
    weheartit: {
      title: "We Heart It",
    },
    screenshot: {
      title: "Screenshot",
      button: "Screenshot maken",
      label: "URL van webpagina",
      placeholder: "Voer een URL in",
      loading: "Bezig met het maken van een screenshot...",
    },
    search: {
      button: "Zoeken op $1$",
      label: "Zoek een afbeelding",
      placeholder: "Zoek naar iets",
      imagesPoweredBy: "Afbeeldingen mogelijk gemaakt door $1$",
    },
    giphy: {
      title: "GIPHY",
    },
    unsplash: {
      title: "Unsplash",
    },
    pixabay: {
      title: "Pixabay",
    },
    pexels: {
      title: "Pexels",
    },
  },
  effects: {
    preview: {
      title: "Voorbeeld",
    },
    filters: {
      title: "Filters",
    },
    crop: {
      title: "Bijsnijden",
      aspectRatios: {
        free: "Free",
        square: "Plein",
      },
    },
    rotate: {
      title: "Draaien",
    },
    flip: {
      title: "Omdraaien",
      buttons: {
        horizontal: "Horizontaal",
        vertical: "Verticaal",
      },
    },
    sharpen: {
      title: "Verscherpen",
    },
    blur: {
      title: "Vervagen",
    },
    brightness: {
      title: "Helderheid",
    },
    contrast: {
      title: "Contrast",
    },
    grayscale: {
      title: "Grijstinten",
    },
    "hue-rotate": {
      title: "Tint roteren",
    },
    invert: {
      title: "Omkeren",
    },
    saturate: {
      title: "Verzadigen",
    },
    sepia: {
      title: "Sepia",
    },
  },
};
